// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge__cbd.withInnerBadge__fa8 {
  padding-right: calc(var(--ring-unit));
}

.forceBadge__b3a {
  margin-left: var(--ring-unit);
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/common/action-badge/action-badge.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;AACvC;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".badge.withInnerBadge {\n  padding-right: calc(var(--ring-unit));\n}\n\n.forceBadge {\n  margin-left: var(--ring-unit);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `badge__cbd`,
	"withInnerBadge": `withInnerBadge__fa8`,
	"forceBadge": `forceBadge__b3a`
};
export default ___CSS_LOADER_EXPORT___;
